import { calendarsQueryOptions } from "@/api/calendars.api";
import { columns } from "@/components/calendars/calendars.columns";
import { DataTable } from "@/components/table/table";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { useSuspenseQuery } from "@tanstack/react-query";
import { Outlet } from "@tanstack/react-router";
import { useState } from "react";
import { CalendarForm } from "./calendars/calendar-form";

export function Calendars() {
  const calendarsQuery = useSuspenseQuery(calendarsQueryOptions);
  const calendars = calendarsQuery.data;
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

  const handleCreateSuccess = () => {
    setIsCreateDialogOpen(false);
  };

  return (
    <div className="flex flex-1 p-8 justify-around gap-8">
      <div className="flex flex-col space-y-8 w-full xl:w-3/4 lg:max-w-4xl xl:max-w-6xl">
        <div className="flex items-center justify-between space-y-2">
          <div>
            <h2 className="text-2xl font-bold tracking-tight">Calendars</h2>
            <p className="text-muted-foreground">
              Manage your organization's calendars and events.
            </p>
          </div>
          <div className="flex items-center space-x-2">
            <Dialog
              open={isCreateDialogOpen}
              onOpenChange={setIsCreateDialogOpen}
            >
              <DialogTrigger asChild>
                <Button>Create Calendar</Button>
              </DialogTrigger>
              <DialogContent className="max-w-2xl">
                <DialogHeader>
                  <DialogTitle>Create New Calendar</DialogTitle>
                  <DialogDescription>
                    Create a new calendar to organize your events.
                  </DialogDescription>
                </DialogHeader>
                <CalendarForm
                  onSuccess={handleCreateSuccess}
                  showCard={false}
                />
              </DialogContent>
            </Dialog>
          </div>
        </div>
        <Outlet />
        <DataTable data={calendars} columns={columns} filterColumn="name" />
      </div>
    </div>
  );
}
